module.exports = __webpack_public_path__ + "img/hedgehog.4400643.png";